import { reverse } from 'named-urls'
import React from 'react'
import { Link } from 'react-router-dom'

import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { List, Table, useMediaQueryContext } from '@fourthwall/components'
import { routing } from '@utils/routing'

import { useShopTime } from '../../../../../../../../../Timezone/providers/ShopTimeProvider'
import type { Donation } from '../../DonationsList.types'
import { getTableHeaders } from '../../utils/getTableHeaders'
import { DonationListItem } from '../DonationListItem/DonationListItem'

type DonationsDataProps = {
  data: Donation[]
  isLoading: boolean
}

const getDonationLink = (donation: any) => ({
  pathname: reverse(routing.contributions.orders.donations.donation.self, {
    donationId: donation.id,
  }),
  search: location.search,
})

export const DonationsData = ({ data, isLoading }: DonationsDataProps) => {
  const { hasPermission } = useDashboardPermissions()
  const media = useMediaQueryContext()
  const { timezoneAbbreviation } = useShopTime()

  if (!media.tablet) {
    return (
      <List
        data={data}
        isLoading={isLoading}
        renderItem={(donation: Donation) => <DonationListItem donation={donation} />}
        getItemLink={getDonationLink}
      />
    )
  }

  return (
    <Table
      data={data}
      headers={getTableHeaders({
        hideProfitColumn: !hasPermission('contributions.profit'),
        timezoneAbbreviation,
      })}
      isLoading={isLoading}
      rowComponent={Link}
      getRowLink={getDonationLink}
    />
  )
}
